import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 2rem;
  padding-top: 70px;
  padding-bottom: 70px;

  /* & :last-child {
    border-bottom: none;
  } */
`;

export const ItemBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  &.header-text {
    column-gap: 2rem;
  }

  &.show-all {
    column-gap: 1rem;
  }
`;

export const LectureWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 3rem 0;
  border-bottom: 1px solid var(--color-border);

  > button {
    height: 4.5rem;
  }
`;

export const LectureTextWrapper = styled.a`
  display: flex;
  flex-direction: column;
  row-gap: 0.6rem;
  cursor: pointer;
`;

export const LectureBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3rem;

  .chat {
    transform: scaleX(-1);
  }

  > button {
    height: 4.6rem;
  }
`;

export const ButtonContainer = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
  width: 100%;
  display: flex;
  gap: 1rem;
`;

export const SelectStyle = styled.select`
  background-color: #1e1b24;
  border: 1px solid #ccc;
  border-radius: 15px;
  color: white;
  padding: 8px 12px;
  font-size: 16px;
  cursor: pointer;
`;

export const StyledImage = styled.img`
  width: 70px; // 원하는 너비
  height: 70px; // 원하는 높이
  border-radius: 50%; // 동그라미 형태를 만들기 위한 border-radius
  object-fit: cover; // 이미지가 영역에 맞게 잘리도록
`;

export const BadgeContainer = styled.div<{
  bgColor: string;
}>`
  width: 47px; // 원하는 너비
  height: 24px; // 원하는 높이
  border-radius: 4px; // 사각형 배지 형태를 만들기 위한 border-radius
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  background-color: ${props => props.bgColor}; // 배경 색상
`;

export const BadgeText = styled.span`
  color: white; // 텍스트 색상
  font-size: 14px; // 텍스트 크기
  font-weight: bold; // 텍스트 굵기
`;

export const SearchBarStyle = styled.input`
  width: 100%;
  height: 52px;
  padding-left: 16px;
  border-radius: 8px;
  outline: 0;
  border-width: 0;
  color: ${({ theme }) => theme.palette.grayscale300};
  border: 1px solid ${({ theme }) => theme.palette.bg500};
  background-color: ${({ theme }) => theme.palette.bg800};
  transition: background-color 0.1s;
  ${({ theme }) => theme.typography('$body_03')};

  &::placeholder {
    color: ${({ theme }) => theme.palette.grayscale600};
  }

  &:focus {
    background-color: ${({ theme }) => theme.palette.grayscale200};
    color: ${({ theme }) => theme.palette.grayscale800};
  }
`;

export const ChipButtonsWrapper = styled.div`
  padding-top: 5px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
